import { CardAnimation } from '@app/shared/types/pages/dailyCardResult';
import { defaultTaroCardImage, taroCardTwoIcon } from '@app/assets';

export const ADVICE_ICONS = ['💁🏻', '🔮', '🙌🏻'];

export const CARD_ANIMATIONS: CardAnimation[] = [
  {
    src: taroCardTwoIcon,
    className: 'absolute w-[218px] opacity-80',
    config: {
      from: { opacity: 0, x: -1000, rotate: '-30deg' },
      to: { opacity: 1, x: 90, y: 31, rotate: '0deg' },
      delay: 650,
    },
  },
  {
    src: taroCardTwoIcon,
    className: 'absolute w-[233px]',
    config: {
      from: { opacity: 0, x: -1000, rotate: '30deg' },
      to: { opacity: 1, x: 52, y: 24, rotate: '0deg' },
      delay: 850,
    },
  },
  {
    src: defaultTaroCardImage,
    className: 'relative w-full rounded-3xl',
    config: {
      from: { opacity: 0, x: -1000, rotate: '-10deg' },
      to: { opacity: 1, x: 0, rotate: '0deg' },
      delay: 1050,
    },
  },
];
